import React from "react";
import { Outlet } from "react-router-dom";

// Manažer → Trenéři. Navigace (Úkoly / Rozvrh / Vzorový rozvrh / Reporting coaches)
// je v sidebaru jako dropdown, proto tu horní lištu záložek nemáme.
export default function TreneriLayout() {
  return <Outlet />;
}
